import React from 'react';
import './App.css';
import SearchScreen from './screens/SearchScreen';

function App() {
  return (
    <div className="App">
      <SearchScreen></SearchScreen>
    </div>
  );
}

export default App;
